<template>
  <div id="app">
    <div class="background"/>
    <router-view/>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'BaseLayout',

  computed: {
    ...mapGetters('Viewer', {viewerId: 'id'})
  },

  methods: {},

  async created() {
    await this.$store.dispatch('Viewer/init')
    await this.$store.dispatch('SignalR/start', this.viewerId)
  }
}
</script>

<style lang="scss" src="./styles/tachyons.min.css"></style>
<style lang="scss" src="./styles/main.scss"></style>



// WEBPACK FOOTER //
// src/App.vue